"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const DynamicIntegrationLogo_1 = require("./DynamicIntegrationLogo");
const react_2 = require("@osmosys/react");
exports.commonLeftTabs = (id, integrationType) => [
    {
        id: 'home',
        name: (react_1.default.createElement(react_2.OsmosysTooltip, { label: integrationType },
            react_1.default.createElement(DynamicIntegrationLogo_1.DynamicIntegrationLogo, { integrationType: integrationType }))),
        to: `/integrations/${id}`,
    },
];
exports.commonRightTabs = (id) => [
    {
        adminRole: 'workspace',
        id: 'settings',
        name: 'Settings',
        to: `/integrations/${id}/settings`,
    },
    {
        adminRole: 'app',
        id: 'admin',
        name: 'Admin',
        to: `/integrations/${id}/admin`,
    },
];
//# sourceMappingURL=commonTabs.js.map